import { trackEvent } from "@/services/analytics";

const GITCHA_EXPLAINER_URL = `${
  process.env.REACT_APP_BLS_MARKETING_URL || "https://thebuyerlistingservice.com"
}/gitcha-syndication`;

export const gitchaExplainerUrl = (surface) =>
  `${GITCHA_EXPLAINER_URL}?utm_source=bls_app&utm_medium=referral&utm_campaign=gitcha_explainer&utm_content=${surface}`;

export const trackGitchaExplainerClick = (surface) =>
  trackEvent({ name: "gitcha_explainer_link_clicked", attributes: { surface } });
